import React, {PropTypes} from 'react';

const AuditBowlerHeader = ({
  bowlerNationalId,
  bowlerName,
  email,
  gender,
  tournamentName
}) => {
  return (
  <div className="list-group-item-labeled"> 
    <div className="list-group-item-labeled-child"
      style={{width: 200}}>
      <span>{'National ID'}</span>
      <span>{bowlerNationalId ? `${bowlerNationalId}` : 'Loading...'}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 120}} >
      <span>{'Name'}</span>
      <span>{bowlerName}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 300}}>
      <span>{'Email'}</span>
      <span>{email}</span>
    </div> 
    <div className="list-group-item-labeled-child"
      style={{width: 100}}>
      <span>{'Gender'}</span>
      <span>{gender}</span>
    </div> 
    <div className="list-group-item-labeled-child"
      style={{width: 250}}>
      <span>{'Tournament'}</span>
      <span>{tournamentName}</span>
    </div> 
  </div>
  );  
};

AuditBowlerHeader.propTypes = {
  tournamentName: PropTypes.string,
  bowlerNationalId: PropTypes.string,
  bowlerName: PropTypes.string,
  email: PropTypes.string,
  gender: PropTypes.string
};

AuditBowlerHeader.defaultProps = {
};

export default AuditBowlerHeader;



// WEBPACK FOOTER //
// ./src/features/admin/audit/bowlerAudit/AuditBowlerHeader.jsx